export default __webpack_public_path__ + "static/do-maintain-spatial-anchors-395f5dd29167e117601b7717cfb07c18.png";